import $ from 'jquery';

export default class CategoryBanner {
    constructor() {
        this.init();
    }

    init() {
        $('#toggle_more').on('click', this.categoryDescriptionToggle);
    }

    categoryDescriptionToggle() {
        let $img = $('.banner-img img');
        let $desc = $('.short-description');

        $desc.toggleClass('more');

        let more = $desc.hasClass('more');
        let read = more ? 'read less..' : 'read more...';

        $img.animate({
            width: more ? 500 : 200,
            height: more ? 500 : 200
        }, 200);

        $('#toggle_more').text(read);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new CategoryBanner();
});
